import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AllocationReduceDepartmentAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AllocationReduceDepartment";
  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/department-allocation-reduce";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }
}

export default new AllocationReduceDepartmentAPI();
